import { createSlice, CaseReducer, PayloadAction } from "@reduxjs/toolkit";

type INotificationState = {
    snackbarOpen: boolean;
    snackbarType: string | null;
    snackbarMessage: string | null;
};

const initialState: INotificationState = {
    snackbarOpen: false,
    snackbarType: "",
    snackbarMessage: "",
};

// ***************************************
// Reducers
// ****************************************

const notification: CaseReducer<INotificationState, PayloadAction<any>> = (
    state,
    { payload }
) => {
    state.snackbarOpen = payload.snackbarOpen;
    state.snackbarType = payload.snackbarType;
    state.snackbarMessage = payload.snackbarMessage;
};

const resetNotification: CaseReducer<INotificationState> = (state) => {
    state.snackbarOpen = false;
    state.snackbarType = "";
    state.snackbarMessage = "";
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        notification,
        resetNotification,
    },
});

export const { name, actions } = notificationSlice;

export default notificationSlice.reducer;
